import { createSelector } from 'reselect';

export const quizSelector = (state) => state.quiz;

export const questionsSelector = createSelector(quizSelector, (quiz) => quiz.questions);
export const currentQuestionSelector = createSelector(quizSelector, (quiz) => quiz.currentQuestion);
export const progressIndexSelector = createSelector(quizSelector, (quiz) => quiz.progressIndex);
